/** Local calendar date as YYYY-MM-DD (matches Firestore report doc ids). */
export function localReportDateKey(date = new Date()): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function fmtReportDateLabel(dateKey: string): string {
  const [y, m, d] = dateKey.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  return dt.toLocaleDateString([], { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
}

export function pickPreferredReportDate(
  availableDates: string[],
  previous: string | null,
  preferToday = true,
): string | null {
  if (previous && availableDates.includes(previous)) return previous;
  if (preferToday) {
    const today = localReportDateKey();
    if (availableDates.includes(today)) return today;
  }
  return availableDates[0] ?? null;
}
